import React from 'react'
import { ReactComponent } from './document.svg'
import { MergeReactElementProps } from '../types'

interface DocumentProps {
  color?: string
}

type Props = MergeReactElementProps<'svg', DocumentProps>

export const Document = React.forwardRef(
  (props: Props, ref: React.Ref<SVGSVGElement>) => {
    const { color = '#9a9a9a' } = props
    return <ReactComponent fill={color} ref={ref} {...props} />
  }
)
